export const RESOURCE_LINK_ALREADY_EXISTS_CODE = 'RESOURCE_LINK_ALREADY_EXISTS';

export const RESOURCE_LINK_DUPLICATE_INFO = {
  title: 'Link Already Added',
  message: 'This link has already been added. Please check with the other ICs.',
} as const;

export function isDuplicateProjectResourceLink(
  links: Array<{ url: string; id?: number }>,
  url: string,
  excludeId?: number | null,
): boolean {
  const normalized = url.trim();
  if (!normalized) return false;
  return links.some(
    (link) => link.url.trim() === normalized && (excludeId == null || link.id !== excludeId),
  );
}

export function isResourceLinkAlreadyExistsError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const maybeCode = (error as { code?: unknown }).code;
  return maybeCode === RESOURCE_LINK_ALREADY_EXISTS_CODE;
}
